module.exports = __webpack_public_path__ + "img/img-2.03f4858d.jpg";